import { render, staticRenderFns } from "./StockValuationReport.vue?vue&type=template&id=bd926ec6"
import script from "./StockValuationReport.vue?vue&type=script&lang=js"
export * from "./StockValuationReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports